const ROLE_LABELS: Record<string, string> = {
  owner: 'Владелец',
  admin: 'Администратор',
  operator: 'Оператор',
  trainee: 'Стажер',
  shift_lead: 'Старший смены',
  npc_helper: 'NPC Helper',
  human_helper: 'Human Helper',
  analyst: 'Аналитик',
  viewer: 'Наблюдатель',
  customer: 'Клиент',
}

/** Роль «Клиент» не показывается в UI-списках ролей сотрудников. */
export function isWorkspaceCustomerRole(role: string | null | undefined): boolean {
  return String(role || '').toLowerCase() === 'customer'
}

/** Фильтр для селектов/матриц: без Клиента (и опционально без Владельца). */
export function isRoleListedInStaffPickers(
  role: string | null | undefined,
  opts?: { includeOwner?: boolean },
): boolean {
  const r = String(role || '').toLowerCase()
  if (!r || isWorkspaceCustomerRole(r)) return false
  if (opts?.includeOwner === false && r === 'owner') return false
  return true
}

export function workspaceRoleLabel(role: string | null | undefined): string {
  const r = String(role || '').toLowerCase()
  return ROLE_LABELS[r] || String(role || '')
}
